import { Reaction, ReactionType } from '../types/reactions'

export const reactionTypes: ReactionType[] = [
  'like',
  'love',
  'laugh',
  'confused',
  'dislike',
  'sad',
  'thankful',
  'wow',
  'angry',
  'angel',
  'problem',
  'party',
]

export const reactionIcons: Record<Reaction['type'], string> = {
  like: '👍',
  love: '❤️',
  laugh: '😂',
  confused: '😕',
  dislike: '👎',
  sad: '😢',
  thankful: '🙏',
  wow: '😲',
  angry: '😡',
  angel: '😇',
  problem: '😱',
  party: '🎉',
}
